var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "primary-cost-estimate" },
    [
      _c(
        "b-modal",
        {
          attrs: { active: _vm.isModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isModalActive = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "box modal-content" },
            [
              _c(
                "b-field",
                {
                  attrs: {
                    "custom-class": "has-text-white has-size-5",
                    label: "Name",
                  },
                },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.pcSumName,
                      callback: function ($$v) {
                        _vm.pcSumName = $$v
                      },
                      expression: "pcSumName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-field",
                {
                  attrs: {
                    "custom-class": "has-text-white has-size-5",
                    label: "Value",
                  },
                },
                [
                  _c("b-input", {
                    attrs: { type: "number" },
                    model: {
                      value: _vm.pcSumValue,
                      callback: function ($$v) {
                        _vm.pcSumValue = $$v
                      },
                      expression: "pcSumValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addPCSum()
                    },
                  },
                },
                [_vm._v("Add")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.togglePCSumInput(false)
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isVisible
        ? _c(
            "button",
            {
              staticClass: "button is-size-5 PCEButton",
              on: { click: _vm.toggleVisibility },
            },
            [
              _vm._v(
                "Show PCE:\n    " +
                  _vm._s(_vm._f("currencyNotReduced")(_vm.totalWithProfit)) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "primary-cost-estimate-controller" }, [
        _c("div", { staticClass: "estimate-builder-container" }, [
          _vm.isVisible
            ? _c(
                "section",
                { staticClass: "estimate-config-container box white" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        "custom-class": "has-text-primary",
                        label: "Job Type",
                      },
                    },
                    [
                      _c("b-input", {
                        attrs: {
                          value: _vm.jobType,
                          expanded: "",
                          disabled: "",
                          readonly: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("icon-and-card", {
                        attrs: {
                          "card-image": _vm.jobTypeModifierDescription.image,
                          "card-text": _vm.jobTypeModifierDescription.text,
                          position: "is-right",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        "custom-class": "has-text-primary",
                        label: "Location",
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "control is-expanded" },
                        [
                          _c(
                            "b-dropdown",
                            {
                              attrs: {
                                "mobile-modal": true,
                                "open-on-focus": true,
                                "aria-role": "list",
                                expanded: "",
                                scrollable: "",
                                size: "is-medium",
                              },
                              on: {
                                input: function (option) {
                                  return (_vm.selectedLocation = option)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "trigger",
                                    fn: function (ref) {
                                      var active = ref.active
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            "icon-right": active
                                              ? "caret-up"
                                              : "caret-down",
                                            value: _vm.selectedLocation
                                              ? _vm.selectedLocation.region
                                              : "Select Location",
                                            expanded: "",
                                            readonly: "",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2005978401
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm._l(_vm.locationModifiers, function (option) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: option.region,
                                    attrs: { value: option },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(option.region) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("icon-and-card", {
                        attrs: {
                          "card-image": _vm.locationModifierDescription.image,
                          "card-text": _vm.locationModifierDescription.text,
                          position: "is-right",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.workSectionsConfigWithModifiers,
                    function (workSection, index) {
                      return _c(
                        "b-field",
                        {
                          key: index,
                          attrs: {
                            label: workSection.label + " Type",
                            "custom-class": "has-text-primary",
                          },
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "control is-expanded" },
                            [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    "mobile-modal": true,
                                    "open-on-focus": true,
                                    "aria-role": "list",
                                    expanded: "",
                                    size: "is-medium",
                                  },
                                  on: {
                                    input: function (option) {
                                      return _vm.setSelectedModifier(
                                        workSection.name,
                                        option
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "trigger",
                                        fn: function (ref) {
                                          var active = ref.active
                                          return [
                                            _c("b-input", {
                                              attrs: {
                                                "icon-right": active
                                                  ? "caret-up"
                                                  : "caret-down",
                                                value:
                                                  _vm.getSelectedModifierLabelForWorkSection(
                                                    workSection
                                                  ),
                                                expanded: "",
                                                readonly: "",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(
                                    workSection.modifiers,
                                    function (option) {
                                      return _c(
                                        "b-dropdown-item",
                                        {
                                          key: option.name,
                                          attrs: { value: option },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(option.label) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("icon-and-card", {
                            attrs: {
                              "card-image":
                                _vm.getSelectedModifierImageForWorkSection(
                                  workSection
                                ),
                              "card-text":
                                _vm.getSelectedModifierDescriptionForWorkSection(
                                  workSection
                                ),
                              position: "is-right",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "b-field",
                        {
                          attrs: {
                            message: !_vm.invalidSurfaceArea
                              ? ""
                              : "Invalid surface area",
                            type: !_vm.invalidSurfaceArea ? null : "is-danger",
                            "custom-class": "has-text-primary",
                            label: "Surface Area",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { disabled: !_vm.selectedJobType },
                            model: {
                              value: _vm.surfaceAreaInput,
                              callback: function ($$v) {
                                _vm.surfaceAreaInput = $$v
                              },
                              expression: "surfaceAreaInput",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            message: !_vm.invalidMarkupPercentage
                              ? ""
                              : "Invalid mark-up",
                            type: !_vm.invalidMarkupPercentage
                              ? null
                              : "is-danger",
                            "custom-class": "has-text-primary",
                            label: "Profit Margin",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { disabled: !_vm.selectedJobType },
                            model: {
                              value: _vm.markUpPercentage,
                              callback: function ($$v) {
                                _vm.markUpPercentage = $$v
                              },
                              expression: "markUpPercentage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-checkbox",
                        {
                          model: {
                            value: _vm.displayWorkSectionTotalWithMarkUp,
                            callback: function ($$v) {
                              _vm.displayWorkSectionTotalWithMarkUp = $$v
                            },
                            expression: "displayWorkSectionTotalWithMarkUp",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Display work section total with mark-up\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.totalCalculationEnabled
                    ? _c(
                        "b-button",
                        {
                          staticClass: "button",
                          attrs: {
                            disabled:
                              !_vm.selectedJobType || !_vm.surfaceAreaInput,
                            "icon-left": "calculator",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.calculateJobTotal.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-size-5" }, [
                            _vm._v("Calculate Estimate"),
                          ]),
                        ]
                      )
                    : _c(
                        "b-button",
                        {
                          staticClass: "button",
                          attrs: { "icon-left": "file" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openReportGenerator()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-size-5" }, [
                            _vm._v("Run Reports"),
                          ]),
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "totals-container" }, [
                    _c("div", { staticClass: "box expanded has-bg-tertiary" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "total is-size-5 has-text-centered has-text-primary has-text-weight-semibold",
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "total-value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("currencyNotReduced")(_vm.total)
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "box expanded has-bg-tertiary" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "total is-size-5 has-text-centered has-text-primary has-text-weight-semibold",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "total-value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("currencyNotReduced")(
                                    _vm.totalWithProfit
                                  )
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons-container" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: !_vm.totalCalculationEnabled,
                            expanded: "",
                            "icon-left": "plus",
                            type: "button is-info",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.togglePCSumInput(true)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-size-5" }, [
                            _vm._v("Add PCSum"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            expanded: "",
                            "icon-left": "save",
                            type: "button is-success",
                          },
                          on: { click: _vm.saveProjectProgress },
                        },
                        [
                          _c("span", { staticClass: "is-size-5" }, [
                            _vm._v("Save Progress"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isVisible
                    ? _c(
                        "button",
                        {
                          staticClass: "button is-size-5",
                          on: { click: _vm.toggleVisibility },
                        },
                        [_vm._v("Hide PCE")]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deviceIsMobile
            ? _c("section", [
                _c(
                  "section",
                  {
                    staticClass: "estimate-values-container box white",
                    class: { hidden: !_vm.jobConfigLoaded },
                    attrs: { id: "mobileSliders" },
                  },
                  [
                    _vm._l(
                      _vm.calculatedJobWorkSections,
                      function (buildStage, index) {
                        return _c(
                          "div",
                          { staticClass: "build-stage-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "mobileViewSliderLabel" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm._f("title")(index)) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(buildStage, function (workSection) {
                              return _c(
                                "div",
                                {
                                  staticClass: "work-section",
                                  attrs: { id: "sliderSections" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        id: "mobileSliderLabelAndImage",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-field",
                                        {
                                          staticClass: "work-section-label",
                                          attrs: {
                                            label: workSection.label,
                                            id: "sliderWorkSectionLabel",
                                            "custom-class": "has-text-primary",
                                            horizontal: "",
                                          },
                                        },
                                        [
                                          _c("icon-and-card", {
                                            attrs: {
                                              "card-image":
                                                _vm.getWorkSectionSpecImage(
                                                  workSection
                                                ),
                                              "card-text":
                                                _vm.getWorkSectionSpecText(
                                                  workSection
                                                ),
                                              position:
                                                _vm.getTooltipPosition(index),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { attrs: { id: "mobileSliderSpan" } },
                                    [
                                      _c("b-checkbox", {
                                        attrs: {
                                          value: workSection.enabled,
                                          size: "is-small",
                                        },
                                        model: {
                                          value: workSection.enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              workSection,
                                              "enabled",
                                              $$v
                                            )
                                          },
                                          expression: "workSection.enabled",
                                        },
                                      }),
                                      _vm._v(" "),
                                      !_vm.displayWorkSectionTotalWithMarkUp
                                        ? _c("b-input", {
                                            staticClass: "has-text-right",
                                            attrs: {
                                              disabled: !workSection.enabled,
                                              value: workSection.enabled
                                                ? workSection.calculatedTotalFormatted
                                                : "",
                                              "label-position": "on-border",
                                              "custom-class":
                                                "has-text-primary",
                                              label: "No Mark-up",
                                              readonly: "",
                                            },
                                          })
                                        : _c("b-input", {
                                            staticClass: "has-text-right",
                                            attrs: {
                                              disabled: "",
                                              value: workSection.enabled
                                                ? workSection.calculatedTotalWithMarkUpFormatted
                                                : "",
                                              "label-position": "on-border",
                                              "custom-class":
                                                "has-text-primary",
                                              label: "No Mark-up",
                                              readonly: "",
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("b-slider", {
                                        staticClass: "work-section-slider",
                                        attrs: {
                                          "custom-formatter": function (val) {
                                            return val + "%"
                                          },
                                          disabled: !workSection.enabled,
                                          max: 100,
                                          min: -100,
                                          value: 0,
                                          lazy: "",
                                          size: "is-medium",
                                          "tooltip-type": "is-warning",
                                        },
                                        model: {
                                          value: workSection.percentageChange,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              workSection,
                                              "percentageChange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "workSection.percentageChange",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pc-sums-container" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "label has-text-primary has-half-border-bottom",
                        },
                        [
                          _vm._v(
                            "\n              Extra Provisional Sums\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "columns is-mobile" },
                        _vm._l(_vm.pcSums, function (pcSum, index) {
                          return _c(
                            "div",
                            { staticClass: "column is-4" },
                            [
                              _c(
                                "b-tag",
                                {
                                  attrs: {
                                    "aria-close-label": "Close tag",
                                    closable: "",
                                    size: "is-medium",
                                    type: "is-primary",
                                    attached: "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.removePCSum(index)
                                    },
                                  },
                                },
                                [
                                  _c("p", { staticClass: "has-text-white" }, [
                                    _vm._v(
                                      _vm._s(pcSum.name) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("currencyNotReduced")(
                                            pcSum.value
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ],
                  2
                ),
              ])
            : _c("section", [
                _c(
                  "section",
                  {
                    staticClass: "estimate-values-container box white",
                    class: { hidden: !_vm.jobConfigLoaded },
                    attrs: { id: "sliders" },
                  },
                  [
                    _vm._l(
                      _vm.calculatedJobWorkSections,
                      function (buildStage, index) {
                        return _c(
                          "div",
                          { staticClass: "build-stage-container" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "label has-text-primary has-half-border-bottom",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm._f("title")(index)) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(buildStage, function (workSection) {
                              return _c(
                                "div",
                                {
                                  staticClass: "work-section",
                                  attrs: { id: "sliderSections" },
                                },
                                [
                                  _c("b-checkbox", {
                                    attrs: {
                                      value: workSection.enabled,
                                      size: "is-small",
                                    },
                                    model: {
                                      value: workSection.enabled,
                                      callback: function ($$v) {
                                        _vm.$set(workSection, "enabled", $$v)
                                      },
                                      expression: "workSection.enabled",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-field",
                                    {
                                      staticClass: "work-section-label",
                                      attrs: {
                                        label: workSection.label,
                                        "custom-class": "has-text-primary",
                                        horizontal: "",
                                      },
                                    },
                                    [
                                      _c("icon-and-card", {
                                        attrs: {
                                          "card-image":
                                            _vm.getWorkSectionSpecImage(
                                              workSection
                                            ),
                                          "card-text":
                                            _vm.getWorkSectionSpecText(
                                              workSection
                                            ),
                                          position:
                                            _vm.getTooltipPosition(index),
                                        },
                                      }),
                                      _vm._v(" "),
                                      !_vm.displayWorkSectionTotalWithMarkUp
                                        ? _c("b-input", {
                                            staticClass: "has-text-right",
                                            attrs: {
                                              disabled: !workSection.enabled,
                                              value: workSection.enabled
                                                ? workSection.calculatedTotalFormatted
                                                : "",
                                              "label-position": "on-border",
                                              "custom-class":
                                                "has-text-primary",
                                              label: "No Mark-up",
                                              readonly: "",
                                            },
                                          })
                                        : _c("b-input", {
                                            staticClass: "has-text-right",
                                            attrs: {
                                              disabled: "",
                                              value: workSection.enabled
                                                ? workSection.calculatedTotalWithMarkUpFormatted
                                                : "",
                                              "label-position": "on-border",
                                              "custom-class":
                                                "has-text-primary",
                                              label: "No Mark-up",
                                              readonly: "",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-slider", {
                                    staticClass: "work-section-slider",
                                    attrs: {
                                      "custom-formatter": function (val) {
                                        return val + "%"
                                      },
                                      disabled: !workSection.enabled,
                                      max: 100,
                                      min: -100,
                                      value: 0,
                                      lazy: "",
                                      size: "is-medium",
                                      "tooltip-type": "is-warning",
                                    },
                                    model: {
                                      value: workSection.percentageChange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          workSection,
                                          "percentageChange",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "workSection.percentageChange",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pc-sums-container" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "label has-text-primary has-half-border-bottom",
                        },
                        [
                          _vm._v(
                            "\n              Extra Provisional Sums\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "columns is-mobile" },
                        _vm._l(_vm.pcSums, function (pcSum, index) {
                          return _c(
                            "div",
                            { staticClass: "column is-4" },
                            [
                              _c(
                                "b-tag",
                                {
                                  attrs: {
                                    "aria-close-label": "Close tag",
                                    closable: "",
                                    size: "is-medium",
                                    type: "is-primary",
                                    attached: "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.removePCSum(index)
                                    },
                                  },
                                },
                                [
                                  _c("p", { staticClass: "has-text-white" }, [
                                    _vm._v(
                                      _vm._s(pcSum.name) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("currencyNotReduced")(
                                            pcSum.value
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "total-label mb-1 has-text-centered" }, [
      _c("span", [_vm._v("Total")]),
      _vm._v(" "),
      _c("span", { staticClass: "is-size-7" }, [_vm._v("(ex VAT)")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "total-label mb-1 has-text-centered" }, [
      _c("span", [_vm._v("Total with profit")]),
      _vm._v(" "),
      _c("span", { staticClass: "is-size-7" }, [_vm._v("(ex VAT)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }